import {
  ID,
  ReorderItem,
  ReorderResult,
  Task,
  TaskListItemTypes,
  TaskPriorityOptions,
} from '@griply/types';
import cloneDeep from 'lodash/cloneDeep';

import { filterNewTaskChildIds } from './filter-new-task-child-ids';
import { findParentItem } from './find-parent-item';

export type OnPriorityReorderOptions = {
  updatedItems: readonly ReorderItem[];
  tasksMap: Record<ID, Task>;
};

export const onPriorityReorder = ({
  updatedItems,
  tasksMap,
}: OnPriorityReorderOptions): ReorderResult => {
  const updatedTasks: Task[] = [];
  const updatedSections: ReorderResult['updatedSections'] = [];

  updatedItems.forEach((item) => {
    if (item.type === TaskListItemTypes.Task) {
      if (!tasksMap[item.id]) {
        return;
      }

      const taskToUpdate = cloneDeep(tasksMap[item.id]);
      const priorityItem = findParentItem(updatedItems, item.id);

      taskToUpdate.priority =
        (priorityItem?.id as TaskPriorityOptions) ?? TaskPriorityOptions.None;

      updatedTasks.push(taskToUpdate);
      return;
    }

    if (item.type === TaskListItemTypes.Priority) {
      updatedSections.push({
        id: item.id,
        taskSorting: filterNewTaskChildIds(item.children),
      });
    }
  });

  return { updatedSections, updatedTasks };
};
